import { render, staticRenderFns } from "./SupervisionPage.vue?vue&type=template&id=a3c4a6f0&scoped=true&"
import script from "./SupervisionPage.vue?vue&type=script&lang=js&"
export * from "./SupervisionPage.vue?vue&type=script&lang=js&"
import style0 from "./SupervisionPage.vue?vue&type=style&index=0&id=a3c4a6f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c4a6f0",
  null
  
)

export default component.exports